import { PlanLimitConfigs, BillingCycleConfig } from '../types.ts';

export const BITBUCKET_DEFAULT_BILLING_CYCLE = 'MONTHLY';
export const BITBUCKET_DEFAULT_UNIT_COUNT = 5;

export const BITBUCKET_MIN_ENTERPRISE_USER_COUNT = 201;

export const bitbucketOfferingSkus = {
	free: 'bitbucket-test-free',
	standard: 'bitbucket-std',
	premium: 'bitbucket-premium',
} as const;

export const BITBUCKET_SIGNUP_LIMIT = 35_000;

export const bitbucketOfferingSkusArray = Object.values(bitbucketOfferingSkus);

export const bitbucketPlanLimitConfigs: PlanLimitConfigs[] = [
	{
		planName: 'Free',
		offeringSku: bitbucketOfferingSkus.free,
		recommendationLimit: 0,
		signupLimit: BITBUCKET_SIGNUP_LIMIT,
	},
	{
		planName: 'Standard',
		offeringSku: bitbucketOfferingSkus.standard,
		recommendationLimit: 5,
		signupLimit: BITBUCKET_SIGNUP_LIMIT,
	},
	{
		planName: 'Premium',
		offeringSku: bitbucketOfferingSkus.premium,
		recommendationLimit: 100,
		signupLimit: BITBUCKET_SIGNUP_LIMIT,
	},
];

export const bitbucketBillingCycleConfig: BillingCycleConfig = {
	monthly: true,
	annual: false,
};
